/* eslint-disable @next/next/no-img-element */
'use client'

import Script from 'next/script'
import { useEffect, useState } from 'react'

type AnalyticsPixelsProps = {
  metaPixelId?: string
  tiktokPixelId?: string
}

export const AnalyticsPixels = ({
  metaPixelId,
  tiktokPixelId,
}: AnalyticsPixelsProps) => {
  const [load, setLoad] = useState(false)

  useEffect(() => {
    const handleInteraction = () => {
      setLoad(true)
    }

    // These listeners are added with `once: true`, so they remove themselves automatically after firing once.
    window.addEventListener('scroll', handleInteraction, {
      once: true,
      passive: true,
    })
    window.addEventListener('mousemove', handleInteraction, {
      once: true,
      passive: true,
    })
    window.addEventListener('touchstart', handleInteraction, {
      once: true,
      passive: true,
    })

    // Fallback timer in case the user does not interact
    const timer = setTimeout(() => {
      handleInteraction()
    }, 3000) // 3 seconds

    return () => {
      clearTimeout(timer)
      window.removeEventListener('scroll', handleInteraction)
      window.removeEventListener('mousemove', handleInteraction)
      window.removeEventListener('touchstart', handleInteraction)
    }
  }, [])

  return (
    <>
      {load && (
        <>
          {/* Meta (Facebook) Pixel */}
          {metaPixelId && (
            <>
              <Script id='fb-pixel' strategy='afterInteractive'>
                {`
                  !function(f,b,e,v,n,t,s){
                    if(f.fbq)return;n=f.fbq=function(){
                      n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
                    };
                    if(!f._fbq)f._fbq=n;
                    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
                    t=b.createElement(e);t.async=!0;
                    t.src=v;
                    s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)
                  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                  fbq('init', '${metaPixelId}');
                  fbq('track', 'PageView');
                `}
              </Script>
              <noscript>
                <img
                  height='1'
                  width='1'
                  alt='pixel'
                  style={{ display: 'none' }}
                  src={`https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1`}
                />
              </noscript>
            </>
          )}

          {/* TikTok Pixel */}
          {tiktokPixelId && (
            <Script id='tiktok-pixel' strategy='afterInteractive'>
              {`
                !function (w, d, t) {
                  w.TiktokAnalyticsObject = t;
                  var ttq = w[t] = w[t] || [];
                  ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
                  ttq.setAndDefer = function(t, e) {
                    t[e] = function() {
                      t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                    }
                  };
                  for (var i = 0; i < ttq.methods.length; i++) {
                    ttq.setAndDefer(ttq, ttq.methods[i]);
                  }
                  ttq.instance = function(t) {
                    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
                      ttq.setAndDefer(e, ttq.methods[n]);
                    }
                    return e;
                  };
                  ttq.load = function(e, n) {
                    var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
                    ttq._i = ttq._i || {};
                    ttq._i[e] = [];
                    ttq._i[e]._u = r;
                    ttq._t = ttq._t || {};
                    ttq._t[e] = +new Date;
                    ttq._o = ttq._o || {};
                    ttq._o[e] = n || {};
                    var script = document.createElement("script");
                    script.type = "text/javascript";
                    script.async = true;
                    script.src = r + "?sdkid=" + e + "&lib=" + t;
                    var firstScript = document.getElementsByTagName("script")[0];
                    firstScript.parentNode.insertBefore(script, firstScript);
                  };

                  ttq.load('${tiktokPixelId}');
                  ttq.page();
                }(window, document, 'ttq');
              `}
            </Script>
          )}
        </>
      )}
    </>
  )
}
